import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  MatButtonModule,
  MatCardModule,
  MatIconModule,
  MatListModule,
  MatSidenavModule,
  MatToolbarModule
} from '@angular/material';
import {SidenavComponent} from './sidenav/sidenav.component';
import {CuiSidenavModule} from '@cicero/webui/lib/navigation/sidenav';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatToolbarModule,
    RouterModule,
    MatButtonModule,
    MatListModule,
    MatSidenavModule,
    MatIconModule,
    CuiSidenavModule
  ],
  declarations: [SidenavComponent],
  exports: [
    SidenavComponent
  ]
})
export class NavigationModule {
}



// WEBPACK FOOTER //
// ./src/app/navigation/navigation.module.ts